/*
* Configuration for Customer
*/
export default function () {
  return {
    shortRegistrationInModal: true
  }
}
